import React, { useEffect, useState } from "react";
import ProductList from "../components/ProductList";
import CategoryList from "../components/CategoryList";
import BestSellerProducts from "../components/BestSellerProducts";
import LatestProducts from "../components/LatestProducts";
import QuickDiagnosticTool from "../components/QuickDiagnosticTool";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import MissionStatement from "../components/MissionStatement";
import VehicleList from "../components/VehicleList";
import ArticlesPage from "./ArticlesPage";

const Homepage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [
    "https://proprimemart.com/cdn-cgi/image/width=800,quality=75/lexus3505.jpg",
    "https://proprimemart.com/cdn-cgi/image/width=800,quality=75/lexus3506.jpg",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 30000); // Change slide every 3 seconds
    return () => clearInterval(interval);
  }, [images.length]);
  const [products, setProducts] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const navigate = useNavigate();
  const heroImage = products.length > 0 ? products[0].picture : "";

  

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  return (
    <div className="homepage">
       <Helmet>
                <title>Buy & Sell Used & New Cars in Cameroon | Spare Parts, Tyres, Lubricants & Mechanics - 237Mechanic, Cameroon’s #1 Auto Website
                </title>
                <meta name="description" content="237Mechanic is Cameroon’s #1 automobile website, ensuring your car stays in peak performance. Explore a wide selection of brand-new and used cars for sale, plus high-quality spare parts, lubricants, and tyres. Connect with top mechanics and access expert car advice—all in one place. Visit our website today for the best deals and professional auto services!" />
            </Helmet>
      <div className="relative w-full h-80 overflow-hidden">
  <div
    className="absolute inset-0 flex transition-transform duration-1000"
    style={{
      transform: `translateX(-${currentSlide * 100}%)`,
    }}
  >
    {images.map((src, index) => (
      <div
        key={index}
        className="relative w-full h-80 flex-shrink-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${src})`,
        }}
      >
        {/* Shop Now Button */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2">
          <button
            className="px-6 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-md hover:bg-blue-700"
            onClick={() => {
              window.location.href = `/collections/${"brand-new-cars"}`;
            }}
          >
            See more brand new vehicles in Cameroon
          </button>
        </div>
      </div>
    ))}
  </div>

  {/* Previous Button */}
  <button
    className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
    onClick={() =>
      setCurrentSlide((prev) => (prev - 1 + images.length) % images.length)
    }
  >
    &#8249;
  </button>

  {/* Next Button */}
  <button
    className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
    onClick={() => setCurrentSlide((prev) => (prev + 1) % images.length)}
  >
    &#8250;
  </button>
</div>

      
      <MissionStatement/>
      <CategoryList/>
      <QuickDiagnosticTool/>
      <VehicleList categorySlug={"brand-new-cars"}/>
       {/* Promotional Section */}
      
      <ArticlesPage/>

      {/* FAQ Section */}
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold text-center mb-6">237mechanic.com frequently asked questions.</h2>
        <div>
          {[
            {
              question: "How do i know which type of car is right for me?",
              answer:
                "You should consider what size and speed mean to you,also the class of the car...",
            },
            {
              question: "How often should i change my oil engine?",
              answer:
                "Regular change of the engine oil will keep your car in peak performance. You should change the engine oil atleast every..",
            },
            {
              question: "What is your favourite brand of car",
              answer:
                "I like Mecerdez but Toyota is king when it comes to versatility..",
            },
            {
              question: "Do you do servicing?",
              answer:
                "No. we do not directly do servicing at the moment but we have trusted partners that we will contact to do it for you...",
            },
          ].map((faq, index) => (
            <div key={index} className="border border-gray-300 rounded-md mb-4">
              <button
                onClick={() => toggleAccordion(index)}
                className="flex justify-between w-full p-4 text-lg font-semibold focus:outline-none"
              >
                {faq.question}
                <span>{activeAccordion === index ? "-" : "+"}</span>
              </button>
              {activeAccordion === index && (
                <div className="p-4 text-gray-600">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Homepage;
